import { decodeToken } from 'setup/SetupAxios'

/** Read the currently-signed-in user's id from the JWT. Returns '' if not signed in. */
export function useCurrentUserId(): string {
    const payload = decodeToken()
    return payload?.userId ?? ''
}
